module.exports = __webpack_public_path__ + "static/media/Rimshot808.b5892d28.wav";